const REFRESH_ADMIN = 'REFRESH_ADMIN';

const defaultState = {

};

export default function reduce(state = defaultState, action = {}) {
    switch (action.type) {
        case REFRESH_ADMIN:
            return {...state, ...action.data}
        default :
            return state
    }
}

export const refresh_admin = (data) => {
    return {
        type: REFRESH_ADMIN,
        data
    }
}


// WEBPACK FOOTER //
// ./src/redux/models/admin.js